import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { useHistory } from 'react-router-dom';

import { ModalValIncomeContent } from '../modals';
import {DateRangePicker, Message} from '../../utilites';
import { ActionButton } from '../../common';
import ReportModal from '../../utilites/ReportModal/ReportModal';
import {REPORTS} from '../../../helpers/data-constants';

import '../reports.scss';
import '../../../assets/styles/components/_tables.scss';
import '../../../assets/styles/components/_modal.scss';

import CrossIcon from '../../../assets/icons/cross.svg';
import {useSelector} from 'react-redux';
import {permissionsAccess} from "../../../helpers/common";

const statement = {
  reports: {
    CAR_CLOSURE_OVERPAYMENT: {
      text: 'Реестр переплат',
      category: { type: 'CAR_CLOSURE_OVERPAYMENT', view: 'reports' },
      title: 'Реестр переплат',
      dateRange: true,
      documentType: 'pdf',
    },
    CANCELED_DEAL: {
      text: 'Аннулированные',
      category: { type: 'CANCELED_DEAL', view: 'reports' },
      title: 'Реестр аннулированных микрозаймов',
      dateRange: true,
      documentType: 'pdf',
    },
    ISSUED_AMOUNT: {
      text: 'Выданные микрозаймы',
      category: { type: 'ISSUED_AMOUNT', view: 'reports' },
      title: 'Ведомость выданных микрозаймов',
      dateRange: true,
      documentType: 'pdf',
    },
    EXTENSION_DEAL: {
      text: 'Продления',
      category: { type: 'EXTENSION_DEAL', view: 'reports' },
      title: 'Ведомость продлений',
      dateRange: true,
      documentType: 'pdf',
    },
    RECALCULATION: {
      text: 'Перерасчёта',
      category: { type: 'RECALCULATION', view: 'reports' },
      title: 'Ведомость перерасчёта',
      dateRange: true,
      documentType: 'pdf',
    },
    CLOSURE_DEAL: {
      text: 'Погашенные микрозаймы',
      category: { type: 'CLOSURE_DEAL', view: 'reports' },
      title: 'Ведомость погашенных микрозаймов',
      dateRange: true,
      documentType: 'pdf',
    },
    DELAY_DEAL: {
      text: 'Просрочки',
      category: { type: 'DELAY_DEAL', view: 'reports' },
      title: 'Ведомость начисленных процентов за период льготного срока',
      dateRange: true,
      documentType: 'pdf',
    },
    REALIZED_THINGS: {
      text: 'Реализованное имущество',
      category: { type: 'REALIZED_THINGS', view: 'reports' },
      title: 'Ведомость реализованного невостребованного имущества',
      dateRange: true,
      documentType: 'pdf',
    },
  },
  accounts: {
    CASH_TURNOVER: {
      text: 'Кассовый оборот/день',
      category: { type: 'CASH_TURNOVER', view: 'accounts' },
      title: 'Кассовый оборот/день',
      dateRange: false,
      documentType: 'xlsx',
    },
  },
  inventory: {
    INVENTORY_PURITY: {
      text: 'Инвентаризация д/м',
      category: { type: 'INVENTORY_PURITY', view: 'inventory' },
      title: 'Инвентаризация д/м',
      dateRange: false,
      documentType: 'pdf',
    },
    INVENTORY_THING: {
      text: 'Инвентаризация вещи',
      category: { type: 'INVENTORY_THING', view: 'inventory' },
      title: 'Инвентаризация вещи',
      dateRange: false,
      documentType: 'pdf',
    },
    INVENTORY_STORE: {
      text: 'Инвентаризация магазин',
      category: { type: 'INVENTORY_STORE', view: 'inventory' },
      title: 'Инвентаризация магазин',
      dateRange: false,
      documentType: 'pdf',
    },
    INVENTORY: {
      text: 'Инвентаризация',
      category: { type: 'INVENTORY', view: 'inventory' },
      title: 'Инвентаризация',
      dateRange: false,
      documentType: 'pdf',
    },
  },
  other: {
  },
};

const Reports = () => {
  const [open, setOpen] = useState({ isOpen: false, category: null });
  const [ reportTitle, setReportTitle] = useState('')
  const history = useHistory();
  const {isLoading} = useSelector(({contract}) => contract)
  const { accessRoles, accessFeatures } = useSelector(({ user }) => user);

  const openModal = ({ type, view }) => {
    setOpen({ isOpen: type, category: view });
    setReportTitle(statement[view][type]?.text)
  };

  const closeModal = () => {
    setOpen({ isOpen: false, category: null });
  };

  if (accessFeatures["report.1C"] && permissionsAccess('report.1C')) {
    statement.accounts.CASH_TURNOVER_XML = {
      text: 'Кассовый оборот 1С 8-ка',
      category: { type: 'CASH_TURNOVER_XML', view: 'accounts' },
      title: 'Кассовый оборот 1С 8-ка',
      dateRange: false,
      documentType: 'xml',
    }
  }
  if (accessFeatures['deals.refund_things']) {
    statement.reports.REFUND_THINGS_REGISTRY = {
      text: 'Возврат невостребованного имущества',
      category: { type: 'REFUND_THINGS_REGISTRY', view: 'reports' },
      title: 'Ведомость возврата невостребованного имущества',
      dateRange: true,
      documentType: 'pdf',
    }
  }
  if (accessFeatures["cars.feature"]) {
    statement.inventory.INVENTORY_CAR = {
      text: 'Инвентаризация авто',
      category: { type: 'INVENTORY_CAR', view: 'inventory' },
      title: 'Инвентаризация авто',
      dateRange: false,
      documentType: 'pdf',
    }
    if (accessFeatures["report.data_export"] && permissionsAccess("report.generate.data_export")) {
      statement.other.DATABASE_UPLOAD = {
        text: 'Выгрузка базы',
        category: { type: 'DATABASE_UPLOAD', view: 'other' },
        title: 'Выгрузка базы',
        dateRange: true,
        documentType: 'xml',
      }
    }
    if (permissionsAccess('debt_load.report')) {
      statement.other.DEBT_REPORT = {
        text: 'ПДН',
        category: { type: 'DEBT_REPORT', view: 'other' },
        title: 'ПДН',
        dateRange: false,
        documentType: 'xlsx',
      }
    }
  }
  if(accessFeatures["report.high_risk"] && permissionsAccess('report.generate.high_risk')){
    statement.other.HIGH_RISK = {
      text: 'Высокий риск',
      category: { type: 'HIGH_RISK', view: 'other' },
      title: 'Высокий риск',
      dateRange: true,
      documentType: 'pdf',
    }
  }
  if(accessFeatures["clients.report"]){
    statement.other.CLIENTS_REPORT = {
      text: 'Клиенты',
      category: { type: 'CLIENTS_REPORT', view: 'other' },
      title: 'Клиенты',
      dateRange: true,
      documentType: 'xlsx',
    }
  }
  if(accessFeatures["clients.report"] && 
      permissionsAccess("action.report.generate.client.active_deals")){
      statement.other.CLIENTS_COUNT = {
        text: 'F2102',
        category: { type: 'CLIENTS_COUNT', view: 'other' },
        title: 'F2102',
        dateRange: true,
      }
    }
  if(accessFeatures["clients.report"]){
    statement.other.OPERATIONS_REPORT = {
      text: 'Отчёт по операциям',
      category: { type: 'OPERATIONS_REPORT', view: 'other' },
      title: 'Отчёт по операциям',
      dateRange: true,
      documentType: 'xlsx',
    }
  }

  const createButtons = (data) => {
    return Object.values(data).map((i) => (
      <ActionButton
        key={i.category.type}
        text={i.text}
        styleName={isLoading ? 'reports-disabled-item' : 'button-pillbox'}
        func={openModal}
        param={i.category}
        disabled={isLoading}
      />
    ));
  };

  const goToNBRBPage = () => {
    history.push('/cash-desk/reports-nbrb');
  };

  const goToGrossProceedsPage = () => {
    history.push('/cash-desk/reports-grossproceeds')
  }

  return (
    <>
      <div className="content-inner-data-columns">
        <div className="content-inner-data-container">
          <fieldset>
            <div className="content-section-title m-b-0">
              <div className="content-section-title-actionitems">
                <h2>Печать</h2>
              </div>
            </div>
            <div>
            { isLoading && <Message type={"info"} text={`Отчет ${reportTitle} загружается, подождите!`}/>}
            </div>
          </fieldset>
          <fieldset>
            <div className="reports-cardscontainer">
              { accessRoles[REPORTS] && (
                <>
                  {
                    permissionsAccess("reports.registers") &&
                      <div className="reports-cardcolumn w-25">
                        <div className="reports-card">
                          <div className="reports-card-header">
                            {
                              accessFeatures['cashboxNameTypeOne']
                                  ? <h4>Ведомости</h4>
                                  : <h4>Реестры</h4>
                            }
                          </div>
                          <div className="reports-card-content">{createButtons(statement.reports)}</div>
                        </div>
                      </div>
                  }
                  {
                      permissionsAccess("reports.global") &&
                      <div className="reports-cardcolumn w-25">
                        <div className="reports-card">
                          <div className="reports-card-header">
                            <h4>Отчёты</h4>
                          </div>
                          <div className="reports-card-content">
                            {createButtons(statement.accounts)}
                          </div>
                        </div>
                      </div>
                  }
                  {
                    permissionsAccess("reports.inventory") &&
                      <div className="reports-cardcolumn w-25">
                        <div className="reports-card">
                          <div className="reports-card-header">
                            <h4>Инвентаризация</h4>
                          </div>
                          <div className="reports-card-content">
                            {createButtons(statement.inventory)}
                          </div>
                        </div>
                      </div>
                  }
                </>
              )}
              {
                permissionsAccess("reports.others") && (
                <div className="reports-cardcolumn w-25">
                  <div className="reports-card">
                    <div className="reports-card-header">
                      <h4>Прочее</h4>
                    </div>
                    <div className="reports-card-content">
                      { accessFeatures['report.nbrb'] && permissionsAccess('report.generate.nbrb') &&
                        <ActionButton text="НБРБ" styleName={isLoading ? 'reports-disabled-item' : 'button-pillbox'} disabled={isLoading} func={goToNBRBPage}/>
                      }
                      {permissionsAccess("action.report.generate.gross_income") && accessFeatures['report.gross_income'] && (
                              <ActionButton text="Валовый доход" styleName={isLoading ? 'reports-disabled-item' : 'button-pillbox'} disabled={isLoading} func={goToGrossProceedsPage} />
                          )}
                      {createButtons(statement.other, 'other')}
                      <ReactModal
                        isOpen={false}
                        contentLabel="Modal"
                        className="modal-container"
                        overlayClassName="modal-overlay">
                        <div className="modal-header">
                          <div>
                            <h2 className="m-b-spacer">
                              <span>Валовый доход за </span>
                            </h2>
                            <DateRangePicker coverClass={'form-element m-b-0'} />
                          </div>
                          <button className="button-icontrigger modal-closetrigger">
                            <span className="icon">
                              <CrossIcon />
                            </span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <ModalValIncomeContent />
                        </div>
                      </ReactModal>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </fieldset>
        </div>
        {/*<ReportsAside />*/}
      </div>
      <ReportModal
        open={open.isOpen}
        onClose={closeModal}
        dateRange={open.category && statement[open.category][open.isOpen]?.dateRange}
        title={open.category && statement[open.category][open.isOpen]?.title}
        documentType={open.category && statement[open.category][open.isOpen]?.documentType}
        type={open.category && statement[open.category][open.isOpen]?.category.type}
      />
    </>
  );
};

export default Reports;
